import { BOARD_SIZE } from './gameConstants.js'

/**
 * 将二维坐标转换为一维数组索引
 * @param {number} row - 行索引 (0-7)
 * @param {number} col - 列索引 (0-7)
 * @returns {number} 一维数组索引
 */
export function toIndex(row, col) {
  return row * BOARD_SIZE + col
}

/**
 * 将一维数组索引转换为二维坐标
 * @param {number} index - 一维数组索引
 * @returns {[number, number]} [行索引, 列索引]
 */
export function toCoord(index) {
  return [Math.floor(index / BOARD_SIZE), index % BOARD_SIZE]
}

/**
 * 检查坐标是否在棋盘范围内
 * @param {number} row - 行索引
 * @param {number} col - 列索引
 * @returns {boolean} 是否在范围内
 */
export function isValidCoord(row, col) {
  return row >= 0 && row < BOARD_SIZE && col >= 0 && col < BOARD_SIZE
}

/**
 * 创建空棋盘
 * @returns {number[]} 64个空位的数组
 */
export function createEmptyBoard() {
  return new Array(64).fill(0)
}

/**
 * 初始化标准开局棋盘
 * @returns {number[]} 初始化后的棋盘
 */
export function createInitialBoard() {
  const board = createEmptyBoard()

  // 标准开局：中心4子
  board[toIndex(3, 3)] = 2 // 白棋
  board[toIndex(3, 4)] = 1 // 黑棋
  board[toIndex(4, 3)] = 1 // 黑棋
  board[toIndex(4, 4)] = 2 // 白棋

  return board
}

/**
 * 棋盘坐标文案（列 a–h，自下而上 1–8）
 * @param {number} index 0–63
 * @returns {string} 如 "d3"
 */
export function formatSquare(index) {
  const [row, col] = toCoord(index)
  const file = String.fromCharCode(97 + col)
  const rank = BOARD_SIZE - row
  return `${file}${rank}`
}